import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export function EmailSentIcon() {
  return _jsxs("svg", {
    width: "160",
    height: "160",
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "emailSentIcon",
    children: [_jsx("rect", {
      width: "160",
      height: "160",
      fill: "white"
    }), _jsx("path", {
      d: "M61.8138 88.152C38.8574 87.4151 21.8914 68.9852 22.9894 49.3766C23.9925 31.4616 52.7198 9.93755 73.6272 9.02928C96.4875 8.03617 100.682 32.5028 101.379 52.1498C102.073 71.7495 84.6914 88.8863 61.8138 88.152Z",
      fill: "#E6EFFF"
    }), _jsx("path", {
      d: "M76.2866 107.97L56.3145 101.521",
      stroke: "#813B19",
      strokeWidth: "2.06266",
      strokeLinecap: "round"
    }), _jsx("path", {
      d: "M83.1414 27.5039L41.1777 50.7773L58.4507 78.5317L86.8548 85.1436L114.096 68.319L87.2065 28.4787C86.3091 27.1491 84.5442 26.7258 83.1414 27.5039Z",
      fill: "#1E6DEB"
    }), _jsx("path", {
      d: "M55.1735 26.8999C55.5316 25.9214 56.5633 25.3636 57.5781 25.5999L111.85 38.2331C113.022 38.5059 113.712 39.7205 113.347 40.8675L106.287 63.0565L102.517 88.1748L44.2932 74.6215L45.011 67.6818C46.2569 55.6345 48.9926 43.7882 53.1553 32.4144L55.1735 26.8999Z",
      fill: "white"
    }), _jsx("path", {
      d: "M41.0623 51.2803L58.9497 77.9667L87.3524 84.5782L114.494 68.3735L103.722 114.648C103.464 115.758 102.355 116.448 101.245 116.19L31.8318 100.032C30.7223 99.7733 30.0322 98.6645 30.2905 97.555L41.0623 51.2803Z",
      fill: "#CCDFFF"
    }), _jsx("path", {
      d: "M57.4776 77.6902L109.253 52.0092C107.585 58.8864 106.497 65.8913 105.999 72.9503L105.971 73.3442L88.7867 84.9783L57.4776 77.6902Z",
      fill: "#E6EFFF"
    }), _jsx("line", {
      x1: "55.2636",
      y1: "57.1409",
      x2: "93.1812",
      y2: "65.9672",
      stroke: "#0452D0",
      strokeWidth: "1.34808",
      strokeLinecap: "round"
    }), _jsx("line", {
      x1: "64.6914",
      y1: "66.758",
      x2: "82.4907",
      y2: "70.9013",
      stroke: "#0452D0",
      strokeWidth: "1.34808",
      strokeLinecap: "round"
    }), _jsx("path", {
      d: "M42.0678 51.5148L58.0785 78.5708L87.174 85.3436L112.578 68.7705C113.356 68.2626 114.356 68.9628 114.146 69.8681L103.371 116.155",
      stroke: "#1E6DEB",
      strokeWidth: "1.34808",
      strokeLinecap: "round"
    }), _jsx("path", {
      d: "M58.0399 78.5619L44.4104 88.5253",
      stroke: "#1E6DEB",
      strokeWidth: "1.34808",
      strokeLinecap: "round"
    }), _jsx("path", {
      d: "M87.2111 85.3516L102.892 115.148",
      stroke: "#1E6DEB",
      strokeWidth: "1.34808",
      strokeLinecap: "round"
    }), _jsx("path", {
      d: "M111.477 45.8432C109.315 51.3589 106.681 60.8127 106.205 70.2024",
      stroke: "#0452D0",
      strokeWidth: "1.34808",
      strokeLinecap: "round"
    }), _jsx("circle", {
      cx: "80.872",
      cy: "46.1686",
      r: "8.7663",
      fill: "#0DA489"
    }), _jsx("path", {
      d: "M77.2625 44.6213L78.8094 49.7779L85.5131 42.5586",
      stroke: "white",
      strokeWidth: "1.95144",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), _jsx("path", {
      d: "M121.127 112.222L117.231 120.153L125.635 116.193L121.127 112.222Z",
      fill: "#3FB5A0"
    }), _jsx("path", {
      d: "M144.032 94.4912L118.111 111.16L117.231 120.154L121.127 112.222L144.032 94.4912Z",
      fill: "#087463"
    }), _jsx("path", {
      d: "M111.575 105.407L144.033 94.4912L118.112 111.16L111.575 105.407Z",
      fill: "#B5E8DF"
    }), _jsx("path", {
      d: "M144.033 94.4912L121.128 112.222L131.754 121.582L144.033 94.4912Z",
      fill: "#B5E8DF"
    }), _jsx("path", {
      d: "M143.797 95.2403L131.754 121.581L127.804 118.104",
      stroke: "#3FB5A0",
      strokeWidth: "1.434",
      strokeMiterlimit: "10",
      strokeLinecap: "round"
    }), _jsx("path", {
      d: "M49.2871 92.1875C49.2871 92.1875 11.9561 119.245 18.8322 139.514C25.7083 159.782 67.1499 152.041 111.576 125.183",
      stroke: "#8591AC",
      strokeWidth: "1.34808",
      strokeMiterlimit: "10",
      strokeLinecap: "round"
    }), _jsx("path", {
      d: "M27.7273 133.649C27.7273 133.649 30.1706 152.975 75.3373 133.024",
      stroke: "#8591AC",
      strokeWidth: "1.34808",
      strokeMiterlimit: "10",
      strokeLinecap: "round"
    }), _jsx("path", {
      d: "M82.2239 130.152L89.6794 126.664",
      stroke: "#8591AC",
      strokeWidth: "1.34808",
      strokeMiterlimit: "10",
      strokeLinecap: "round"
    })]
  });
}